import React from 'react';
import { XIcon } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-291">
      <div className="relative w-full max-w-4xl bg-gray-900 border-2 border-yellow-600/30 rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-292">
        {/* Close button */}
        <button onClick={onClose} className="sticky top-4 float-right mr-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 hover:bg-gray-700 transition-colors z-10" data-id="element-293">
          <XIcon className="w-5 h-5 text-gray-400" data-id="element-294" />
        </button>

        {/* Content */}
        <div className="p-8 md:p-12" data-id="element-295">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-296">
            Términos y{' '}
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent" data-id="element-297">
              Condiciones de Uso
            </span>
          </h1>
          <p className="text-xl text-gray-400 mb-8" data-id="element-298">Tarjeta SAMBOCARD</p>

          <div className="space-y-6 text-gray-300" data-id="element-299">
            {/* 1. NATURALEZA DEL PROGRAMA */}
            <section data-id="element-300">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-301">
                1. NATURALEZA DEL PROGRAMA
              </h2>
              <p className="leading-relaxed" data-id="element-302">
                El presente documento establece los términos y condiciones
                aplicables al uso de la tarjeta de fidelización gratuita
                denominada SAMBOCARD (en adelante, "la Tarjeta"), la cual
                permite a sus titulares acceder a beneficios, descuentos y
                promociones ofrecidos por comercios afiliados al programa.
              </p>
            </section>

            {/* 2. ACCESO A LA TARJETA */}
            <section data-id="element-303">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-304">
                2. ACCESO A LA TARJETA
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-305">
                <li data-id="element-306">
                  La Tarjeta es gratuita y de uso personal e intransferible.
                </li>
                <li data-id="element-307">
                  Podrá acceder a ella cualquier persona natural mayor de edad
                  que complete el formulario de afiliación correspondiente.
                </li>
                <li data-id="element-308">
                  El uso de la Tarjeta implica la aceptación plena de estos
                  términos y condiciones.
                </li>
              </ul>
            </section>

            {/* 3. BENEFICIOS Y PROMOCIONES */}
            <section data-id="element-309">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-310">
                3. BENEFICIOS Y PROMOCIONES
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-311">
                <li data-id="element-312">
                  Los beneficios ofrecidos pueden incluir: descuentos directos,
                  promociones especiales, servicios preferenciales, obsequios u
                  otros incentivos, según lo determine cada comercio afiliado.
                </li>
                <li data-id="element-313">
                  Cada comercio es el único responsable de aplicar, mantener,
                  modificar o cancelar los beneficios que ofrece a los usuarios
                  de la Tarjeta.
                </li>
                <li data-id="element-314">
                  Los beneficios están sujetos a condiciones particulares
                  propias de cada comercio (vigencia, stock, montos mínimos de
                  compra, restricciones, etc.).
                </li>
              </ul>
            </section>

            {/* 4. RESPONSABILIDAD DEL PROGRAMA */}
            <section data-id="element-315">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-316">
                4. RESPONSABILIDAD DEL PROGRAMA
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-317">
                <li data-id="element-318">
                  PromRed, empresa procesadora de La Tarjeta, actúa únicamente
                  como intermediario que conecta a los usuarios con comercios
                  aliados, sin asumir responsabilidad por la calidad,
                  disponibilidad o condiciones de los productos o servicios
                  ofrecidos.
                </li>
                <li data-id="element-319">
                  En caso de cualquier inconveniente o reclamo relacionado con
                  los beneficios, el usuario deberá comunicarse directamente con
                  el comercio correspondiente.
                </li>
              </ul>
            </section>

            {/* 5. VIGENCIA Y MODIFICACIONES */}
            <section data-id="element-320">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-321">
                5. VIGENCIA Y MODIFICACIONES
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-322">
                <li data-id="element-323">
                  La vigencia de la Tarjeta es indefinida, salvo que el usuario
                  o la organización emiten renuncien expresamente a su uso.
                </li>
                <li data-id="element-324">
                  La organización se reserva el derecho de modificar, suspender
                  o cancelar el programa o sus términos y condiciones,
                  informando oportunamente a los usuarios a través de sus
                  canales oficiales.
                </li>
              </ul>
            </section>

            {/* 6. PROTECCIÓN DE DATOS PERSONALES */}
            <section data-id="element-325">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-326">
                6. PROTECCIÓN DE DATOS PERSONALES
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-327">
                <li data-id="element-328">
                  Al afiliarse, el usuario autoriza el tratamiento de sus datos
                  personales conforme a la legislación vigente, exclusivamente
                  para fines informativos y promocionales relacionados con el
                  programa.
                </li>
                <li data-id="element-329">
                  Los datos no serán compartidos con terceros sin consentimiento
                  del titular, salvo requerimiento legal. Puede ver más detalles
                  en el documento de nuestras Políticas de Privacidad y
                  Protección de Datos Personales.
                </li>
              </ul>
            </section>

            {/* 7. USO INDEBIDO Y CANCELACIÓN */}
            <section data-id="element-330">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-331">
                7. USO INDEBIDO Y CANCELACIÓN
              </h2>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-332">
                <li data-id="element-333">
                  El uso fraudulento, indebido o contrario a estos términos
                  puede dar lugar a la anulación inmediata de la Tarjeta y la
                  pérdida de sus beneficios.
                </li>
                <li data-id="element-334">
                  La organización podrá retirar o suspender la tarjeta en caso
                  de mal uso sin necesidad de notificación previa.
                </li>
              </ul>
            </section>

            {/* 8. VIGENCIA */}
            <section data-id="element-335">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-336">8. VIGENCIA</h2>
              <p className="leading-relaxed" data-id="element-337">
                La vigencia de estos Términos y Condiciones de Uso es desde el
                12 de septiembre de 2025 y permanecerá vigente hasta que exista
                una nueva versión que la reemplace.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>;
}